module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/img05-897dbdc41d5930f2ca3038493792bb13.png";